import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { HeaderMenuComponent, TenantLinkDirective } from '@mds/ngx-auth';
import {
  HeaderComponent,
  LoadingIndicatorComponent,
  ShellComponent,
} from '@mds/ngx-layout';
import { RplRoutes } from './navigation/models/rpl-routes.model';

@Component({
  imports: [
    RouterModule,
    ShellComponent,
    HeaderComponent,
    HeaderMenuComponent,
    LoadingIndicatorComponent,
    MatIcon,
    MatButtonModule,
    TenantLinkDirective,
  ],
  selector: 'rpl-root',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  protected readonly title = 'rpl';

  protected readonly RplRoutes = RplRoutes;

  constructor() {
    inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-outlined');
  }
}
